import React, { Component } from 'react';
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form';
import axios from "axios";

import { Row, Col } from 'react-bootstrap';
import {FormattedHTMLMessage} from 'react-intl';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import CustomAlert from './CustomAlert.js';
import FlowProgressBar from './FlowProgressBar.js';
import Header from './Header.js';
import SignatureForm from './SignatureForm';
import ContractContainer from '../containers/ContractContainer.js';

require(`../assets/${process.env.PAGE}/css/components/Contracts.css`)


class Contracts extends Component {

    constructor(props) {
        super(props);
        this.state = {
            contracts: [],
            hasSignature: false,
            signatureRequired: null,
        };

        this.setSignature = this.setSignature.bind(this);
    }

    componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };

        axios.get(`${ROOT_URL}/leads/contracts`, config)
            .then((response) => {
                this.setState({
                    contracts: response.data.contracts
                });
            });

        axios.get(`${ROOT_URL}/leads/signature`, config)
            .then((response) => {
                this.setState({
                    signatureRequired: response.data.required
                });
            });
    }

    getContracts = () => {
        let contractsForm = [];
        const {myContracts} = this.props;

        for (let index in this.state.contracts){
            let accepted = false;
            let name = this.state.contracts[index].contract_type;
            let label = this.state.contracts[index].tile;  // TODO: Fix title misspelling in API

            if (name in myContracts){
                accepted =  myContracts[name].values && myContracts[name].values.contract_accepted;
            }

            let contract = <ContractContainer key={index} form={name} onSubmit={this.props.submitContract}
                                              checked={accepted} label={label} />
            contractsForm.push(contract);
        }

        return contractsForm;
    }

    setSignature = (hasSignature) => {
        this.setState({
            hasSignature: hasSignature
        });
    }

    render() {
        const { handleSubmit, acceptedAllContracts, error } = this.props;
        const { signatureRequired, hasSignature, contracts } = this.state;

        let contractsForm = this.getContracts();

        return (
            <Section className="intro_form">
                <div className="row">
                    <Header>
                        <FlowProgressBar />
                        <FormattedHTMLMessage id="app.step_contracts" defaultMessage="Consentimiento Legal" description="Contracts info" />
                    </Header>
                    <div className='container no-gutters'>
                        <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                            <form onSubmit={handleSubmit(this.props.getStep)} className="pvc-form">
                                {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' />}
                                {error && <CustomAlert bsStyle="danger" message={error} />}
                                <div className="terms">
                                    <FormattedHTMLMessage id="app.contract_advice" defaultMessage="<p>Por favor, abrir, leer y acordar.</p>" description="Advice"/>
                                    {contractsForm}
                                    {signatureRequired && <SignatureForm onChange={this.setSignature} disabled={ contracts.length === 0  || !acceptedAllContracts}/>}
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                        <button
                                            type="submit"
                                            className="btn btn-warning btn-lg pd-button pd-form"
                                            disabled={(!acceptedAllContracts || (signatureRequired && !hasSignature))}
                                        >
                                            Finalizar
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

const selectorTos = formValueSelector('tos')

Contracts = connect(
    state => ({
        myContracts: state.form,
        acceptedAllContracts: Object.values(state.form).filter(x =>  x.values && x.values.contract_accepted === false).length === 0
    }),
)(Contracts)

Contracts = reduxForm({
    form: 'Contracts', // a unique name for this form
})(Contracts);


export default Contracts;



/** WEBPACK FOOTER **
 ** ./src/components/Contracts.js
 **/